<div class="cabana-page">
  <section class="cabana-container">
    <div class="cabana-resumo">
      <div class="resumo-info">
        <h2>Chalé Santorini</h2>
        <p>Um espaço aconchegante e especial para quem busca conforto, tranquilidade e momentos inesquecíveis no Paraíso do Cerrado.</p>
      </div>
    </div>

    <section class="galeria">
      <button type="button" class="galeria-btn galeria-btn-esquerda" (click)="imagemAnterior()" aria-label="Grupo de imagens anterior">‹</button>
      <div class="galeria-slide" [class.fotos-2]="imagensVisiveis.length === 2" [class.fotos-1]="imagensVisiveis.length === 1">
        <div class="galeria-foto" *ngFor="let imagem of imagensVisiveis">
          <img [src]="imagem" alt="Chalé Santorini" draggable="false" loading="lazy">
        </div>
      </div>
      <button type="button" class="galeria-btn galeria-btn-direita" (click)="proximaImagem()" aria-label="Próximo grupo de imagens">›</button>
      <div class="galeria-indicadores">
        <button type="button" *ngFor="let pagina of paginasGaleria; let i = index" [class.ativo]="i === paginaGaleriaAtual" (click)="selecionarImagem(i)" [attr.aria-label]="'Selecionar grupo ' + (i + 1)"></button>
      </div>
    </section>

    <section class="conteudo-grid">
      <div class="conteudo-principal">
        <section class="texto-section">
          <h2>Conheça este espaço</h2>
          <p>O Chalé Santorini, do @paraisodocerradoo, é uma experiência a apenas 60 km de Goiânia. Inspirado na arquitetura da ilha grega, combina o charme de Santorini com a tranquilidade do Cerrado.</p>
          <br>
          <p>Localizado na mesma propriedade da Cabana Ypê, em um condomínio de chácaras/ranchos (o mais próximo fica a 250m), oferece privacidade, segurança e um ambiente para descansar e se desconectar.</p>
          <p>Condições especiais para reservas de 2 dias!</p>
        </section>

        <section class="texto-section">
          <h2>O que há neste espaço?</h2>
          <div class="comodidades-grid">
            <div><strong>Banheiro</strong><ul><li>Chuveiro externo</li></ul></div>
            <div><strong>Entretenimento</strong><ul><li>TV</li></ul></div>
            <div><strong>Climatização</strong><ul><li>Ar-condicionado</li></ul></div>
            <div><strong>Internet e escritório</strong><ul><li>Wi-Fi</li></ul></div>
            <div><strong>Cozinha e sala de jantar</strong><ul><li>Cozinha</li></ul></div>
            <div><strong>Ar livre</strong><ul><li>Lareira externa</li><li>Churrasqueira</li></ul></div>
            <div><strong>Estacionamento e instalações</strong><ul><li>Estacionamento gratuito no local</li><li>Banheira de hidromassagem</li></ul></div>
            <div><strong>Serviços</strong><ul><li>Permitido Pets</li><li>Self check-in</li><li>Cofre de chaves</li></ul></div>
            <div class="comodidades-nao-incluso">
              <strong>Não incluso</strong>
              <ul><li>Câmeras de segurança na parte externa da propriedade</li>
                <li>Máquina de lavar</li>
                <li>Secadora</li>
                <li>Detector de fumaça</li>
                <li>Detector de monóxido de carbono</li>
                <li>Aquecedor</li>
                <li>Café da manhã</li>
              </ul>
            </div>
          </div>
        </section>
      </div>

      <aside class="reserva-card">
        <div class="reserva-card-header">
          <div><span>Valor da hospedagem</span><strong>R$ {{ valorTotal | number:'1.2-2' }}</strong><small *ngIf="dataEntrada && dataSaida"> / {{ quantidadeNoites }} {{ quantidadeNoites === 1 ? 'noite' : 'noites' }}</small></div>
        </div>
        <div class="campo-reserva">
          <label>Acomodação</label>
          <div class="campo-valor"><span>⌂</span><strong>Chalé Santorini</strong></div>
        </div>
        <div class="campo-reserva">
          <label>Check-in</label>
          <button type="button" class="campo-botao" (click)="abrirCalendario('entrada')"><span>▣</span> {{ dataEntrada ? formatarData(dataEntrada) : 'Selecione a data' }}</button>
        </div>
        <div class="campo-reserva">
          <label>Check-out</label>
          <button type="button" class="campo-botao" (click)="abrirCalendario('saida')"><span>▣</span> {{ dataSaida ? formatarData(dataSaida) : 'Selecione a data' }}</button>
        </div>
        <div class="horarios-reserva">
          <div><strong>🕐 Check-in</strong><span>A partir das 12:00</span></div>
          <div><strong>🕙 Check-out</strong><span>Até as 10:00</span></div>
        </div>
        <div class="campo-reserva">
          <label>Hóspedes</label>
          <button type="button" class="campo-botao" (click)="toggleHospedes()"><span>♙</span> {{ totalHospedes }} {{ totalHospedes === 1 ? 'hóspede' : 'hóspedes' }}</button>
          <div class="hospedes-dropdown" *ngIf="mostrarHospedes">
            <div class="hospede-linha">
              <div><strong>Adultos</strong><small>12 anos ou mais</small></div>
              <div class="contador"><button type="button" (click)="alterarHospedes('adultos', -1)">−</button><span>{{ adultos }}</span><button type="button" (click)="alterarHospedes('adultos', 1)">+</button></div>
            </div>
            <div class="hospede-linha">
              <div><strong>Crianças</strong><small>De 2 a 11 anos</small></div>
              <div class="contador"><button type="button" (click)="alterarHospedes('criancas', -1)">−</button><span>{{ criancas }}</span><button type="button" (click)="alterarHospedes('criancas', 1)">+</button></div>
            </div>
            <div class="hospede-linha">
              <div>
                <strong>Pets</strong>
                <small>Pets (máximo 2)</small>
              </div>

              <div class="contador">
                <button
                  type="button"
                  [disabled]="animais <= 0"
                  (click)="alterarHospedes('animais', -1)"
                >
                  −
                </button>

                <span>{{ animais }}</span>

                <button
                  type="button"
                  [disabled]="animais >= 2"
                  (click)="alterarHospedes('animais', 1)"
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="calendario" *ngIf="mostrarCalendario">
          <div class="calendario-header">
            <button type="button" (click)="mesAnterior()" aria-label="Mês anterior">‹</button>
            <strong>{{ nomesMeses[mesAtual] }} {{ anoAtual }}</strong>
            <button type="button" (click)="mesProximo()" aria-label="Próximo mês">›</button>
          </div>
          <p class="calendario-mensagem" *ngIf="carregandoCalendario">Carregando disponibilidade e regras...</p>
          <p class="calendario-erro" *ngIf="erroCalendario">Não foi possível consultar as datas. Atualize a página para tentar novamente.</p>
          <div class="calendario-regra" *ngIf="!carregandoCalendario && !erroCalendario && dataEntrada && modoCalendario === 'saida'">
            <strong>Estadia mínima: {{ minimoNoitesSelecionado }} {{ minimoNoitesSelecionado === 1 ? 'noite' : 'noites' }}</strong>
            <span>Check-in: {{ formatarData(dataEntrada) }}</span>
            <span>Primeiro check-out permitido: {{ formatarData(checkoutMinimo) }}</span>
          </div>
          <div class="calendario-semana"><span>Dom</span><span>Seg</span><span>Ter</span><span>Qua</span><span>Qui</span><span>Sex</span><span>Sáb</span></div>
          <div class="calendario-dias">
            <button type="button" *ngFor="let dia of diasCalendario"
                    [class.vazio]="dia.numero === 0"
                    [class.hoje]="dia.hoje"
                    [class.selecionado]="dia.selecionado"
                    [class.intervalo]="dia.intervalo"
                    [class.dia-bloqueado]="dia.numero !== 0 && dia.desabilitado"
                    [class.dia-checkout-minimo]="modoCalendario === 'saida' && checkoutMinimo !== null && mesmaData(dia.data, checkoutMinimo) && !dia.desabilitado"
                    [class.dia-checkout-disponivel]="modoCalendario === 'saida' && checkoutMinimo !== null && dia.data > checkoutMinimo && !dia.desabilitado && !dia.selecionado && dia.numero !== 0"
                    [disabled]="dia.numero === 0 || dia.desabilitado"
                    (click)="selecionarData(dia)">
              <ng-container *ngIf="dia.numero !== 0">{{ dia.numero }}</ng-container>
            </button>
          </div>
          <div class="calendario-legenda" *ngIf="!carregandoCalendario && !erroCalendario && modoCalendario === 'saida' && dataEntrada">
            <span><i class="legenda-minimo"></i> Primeiro check-out permitido</span>
            <span><i class="legenda-disponivel"></i> Check-out disponível</span>
            <span><i class="legenda-bloqueado"></i> Indisponível</span>
          </div>
          <div class="calendario-footer"><span>{{ modoCalendario === 'entrada' ? 'Selecione o check-in' : 'Selecione o check-out' }}</span></div>
        </div>

        <div class="reserva-total" *ngIf="dataEntrada && dataSaida">
          <div><span>{{ quantidadeNoites }} {{ quantidadeNoites === 1 ? 'noite' : 'noites' }}</span><strong>R$ {{ valorTotal | number:'1.2-2' }}</strong></div>
        </div>
        <button type="button" class="btn-continuar" [disabled]="processando || carregandoCalendario || erroCalendario" (click)="continuarReserva()">
          <span *ngIf="!processando">Continuar para pagamento</span>
          <span *ngIf="processando">Verificando disponibilidade...</span>
        </button>
        <p class="aviso-reserva">Você não será cobrado neste momento. A próxima etapa será o pagamento da reserva.</p>
      </aside>
    </section>

    <section class="avaliacao-section">
      <div class="avaliacao-nota">
        <ng-container *ngIf="avaliacoes.length > 0">
          <strong>{{ mediaAvaliacoes | number:'1.2-2' }}</strong><span>★★★★★</span>
          <small>{{ avaliacoes.length }} {{ avaliacoes.length === 1 ? 'avaliação dos hóspedes' : 'avaliações dos hóspedes' }}</small>
        </ng-container>
        <ng-container *ngIf="avaliacoes.length === 0"><strong>—</strong><small>Ainda não há avaliações</small></ng-container>
      </div>
      <div class="avaliacao-texto" *ngIf="avaliacoes.length > 0">
        <div class="avaliacao" *ngFor="let avaliacao of avaliacoes">
          <div class="avaliacao-cabecalho">
            <strong>{{ avaliacao.nomeHospede }}</strong>
            <span class="estrelas-avaliacao"><ng-container *ngFor="let estrela of [1,2,3,4,5]"><span [class.ativa]="estrela <= avaliacao.nota">★</span></ng-container></span>
          </div>
          <p *ngIf="avaliacao.comentario">{{ avaliacao.comentario }}</p>
        </div>
      </div>
      <div class="sem-avaliacoes" *ngIf="avaliacoes.length === 0"><p>Seja o primeiro hóspede a compartilhar sua experiência.</p></div>
    </section>
    <section class="localizacao">
      <h2>Saiba onde você estará hospedado</h2>
      <div class="mapa"><iframe src="https://www.google.com/maps?q=Para%C3%ADso%20do%20Cerrado%20Goi%C3%A1s&amp;output=embed" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="Localização do Paraíso do Cerrado"></iframe></div>
    </section>
  </section>
</div>
